<!--
     <UserSelector
       :filters='QFilters'
       @update='handle_filters(QFilters)'
     />
NOTE: Currently available users arre filtered by current centro
ideally this behaivour should be parametrizable
-->

<template>
    <GenericSelector
      :items="select_userlist"
      :current_selected="[selected_user_id]"
      :disabled="disabled"
      search
      required
      @update="select_user"
    >
      <template v-slot:activator="{ toggle }">
        <v-btn
          v-if="!is_mobile"
          @click.stop="toggle()"
          class="qmkey-btn-process-filter"
          :loading="loading"
          :class="active ? 'qmkey-btn-process-filter-active' : ''"
        >
          <v-row
            no-gutters
            align="center"
            justify="start"
            class="mr-0 pr-0"
            style="height: 36px"
          >
            <v-col
              cols="auto"
              class="mr-4 text-left"
              tile
              outlined
              style="min-width: 90px"
            >
              {{ selected_user_name }}
            </v-col>
            <v-col
              cols="auto"
              tile
              class="mr-0 border-right"
              style="height: 36px"
            >
              <!--
                  Trick: If you specify a height on a column, then it won't
                  vertically align. So we create an empty one with right border
              -->
            </v-col>
            <v-col
              cols="auto"
              class="ma-0"
              tile
              outlined
            >
              <v-icon right class="icon-large">mdi-chevron-down</v-icon>
            </v-col>
          </v-row>
        </v-btn>
        <v-btn
          v-else
          @click.stop="toggle()"
          :loading="loading"
          icon
          small
        >
          <v-icon small>mdi-account-search</v-icon>
        </v-btn>
      </template>
    </GenericSelector>
</template>


<style>

</style>


<script>
 import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
 import GenericSelector from '@/components/explorer/GenericSelector';
 import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   name: "FilterUser",
   
   components: {
    GenericSelector,
   },
   props: {
     filters: {type: QFilters, required: true},
     is_mobile: {type: Boolean, default: false},
   },

   data: () => ({
     loading: true,
   }),

   computed: {
     ...mapGetters([
       'user',
       'site_id',
       'centro_id',
     ]),

     ...mapState([
       'users',
       'users_map',
     ]),

     userlist() {
      // Filter users by current centro
       return [this.user].concat(
         this.users.filter(u => 
            !u.isAdmin 
            && u.id != this.user.id
            && u.participating_centros.includes(this.centro_id)          
        )
       );
     },

     select_userlist() {
      return this.userlist.map(usr => usr.id === this.user.id ? 
                                      ({id: usr.id, name: usr.first_name +" "+ usr.last_name + " (YO)", style: {'font-style': 'italic'}}) : 
                                      ({id: usr.id, name: usr.first_name +" "+ usr.last_name}) );
     },

     selected_user_id() {
       return this.filters.get_filter_value('current_workflow_responsible') || this.user.id;
     },

     selected_user_name() {
       let usr = this.user;
       if (this.selected_user_id != this.user.id)
         usr = this.users_map[this.selected_user_id];
       return `${usr.first_name} ${usr.last_name}`;
     },

     active() {
       return this.selected_user_id != this.user.id;
     },
   },

   async mounted() {
     if (this.users.length < 1) {
       this.loading = true;
       await this.GET_USERS(this.site_id);
       this.loading = false;
     } else {
       this.loading = false;
     }
     this.current_user = this.user.id;
   },

   methods: {
     ...mapActions(['GET_USERS']),

     select_user(usr_id) {
      if (usr_id && usr_id !== this.selected_user_id) {
        let filters = new QFilters();
        filters.set_filter(get_qfilter('current_workflow_responsible',usr_id));
        this.$emit('update', filters);
      }
     },

     get_value() {
        let res = new QFilters();
        res.set_filter(get_qfilter('current_workflow_responsible',this.selected_user_id));
        return res;
      },
   },
 }
</script>
